import styled from 'styled-components';
import { Container } from 'layout/page/Page.layout.styled';
import { prem } from 'styles/helpers/spacing';
import { SelectBoxWrapper } from 'components/common/form/selectbox/SelectBox.styled';
import { RegularButtonFlexed } from 'components/common/button/Button.styled';
import { FormFieldsGroup } from 'components/common/form/Form.styled';

const QuestionnaireMainWrapper = styled.div`
  height: 100%;

  ${Container} {
    height: 100%;
  }
`;

const QuestionnaireFormIntro = styled.p`
  width: ${prem(400)};
  max-width: 80%;
  margin: 0 auto ${prem(10)} auto;
`;

const QuestionnaireSlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .title-before-questionnaire-starts {
    width: ${prem(400)};
    max-width: 80%;
    margin: ${prem(20)} auto ${prem(34)};
  }

  p {
    color: var(--ion-text-color-secondary);
  }

  .intro-form {
    width: ${prem(400)};
    max-width: 80%;
    margin: 0 auto;
    
    ${FormFieldsGroup} {
      display: flex;
      flex-direction: column;
      gap: 15px;

      > div {
        margin-bottom: 0;
        margin-top: 0;
        min-height: 60px;
      }

      .submit-button {
        margin-top: ${prem(20)};
      }
    }
  }

  ${SelectBoxWrapper} {
    margin-bottom: ${prem(20)};

    ${RegularButtonFlexed} {
      span {
        text-align: start;
        width: 100%;
      }
    }

    select {
      padding-right: ${prem(30)};
    }
  }
`;

const QuestionnaireContent = styled.div`
  flex-grow: 1;
  max-height: 90vh;
  overflow: auto;

  .questionnaire-description {
    margin-bottom: ${prem(40)};
    color: var(--ion-text-color-secondary);

    img {
      user-select: none;
      width: 100%;
      max-width: ${prem(650)};
      display: block;
      margin: 0 auto;
      cursor: normal;
    }
  }
`;

const QuestionnaireFooter = styled.div`
  flex-basis: ${prem(50)};
`;

export {
  QuestionnaireMainWrapper,
  QuestionnaireSlideWrapper,
  QuestionnaireContent,
  QuestionnaireFooter,
  QuestionnaireFormIntro,
};
